import {HttpErrorResponse} from '@angular/common/http';
import {DetailsPageErrorInterface, PtEntity} from '@pt/pt-models';


export class DetailsPageError {

  private error: DetailsPageErrorInterface;

  public entityError(ptEntity: PtEntity): string {
    switch (ptEntity) {
      case "globalMeasureCheck":
      case "riskAssessmentVersions":
        return 'MESSAGE.DETAILS_RISK_ASSESSMENT_ERROR_404';

      case "treatmentsSubResponsible":
      case "treatmentsSubResponsibleVersions":
        return 'MESSAGE.DETAILS_TREATMENT_SUB_RESPONSIBLE_ERROR_404';

      case "treatments":
      case "treatmentsHolder":
      case "treatmentsHolderVersions":
        return 'MESSAGE.DETAILS_TREATMENT_HOLDER_ERROR_404';

      case "treatmentsResponsible":
      case "treatmentsResponsibleVersions":
        return 'MESSAGE.DETAILS_TREATMENT_RESPONSIBLE_ERROR_404';

      case "projectCards":
      case "projectCardsVersions":
        return 'MESSAGE.DETAILS_TREATMENT_PROJECT_ERROR_404';

      case "dataBreach":
        return 'MESSAGE.DETAILS_DATA_BREACH_ERROR_404';

      case "users":
        return 'MESSAGE.DETAILS_USER_ERROR_404';

      case "aiAssessment":
      case "aiAssessmentVersions":
        return 'MESSAGE.DETAILS_AI_ASSESSMENT_ERROR_404';

      case "covidAssessment":
      case "covidAssessmentVersions":
        return 'MESSAGE.DETAILS_COVID_ASSESSMENT_ERROR_404';

      case "appAssessment":
      case "appAssessmentVersions":
        return 'MESSAGE.DETAILS_APP_ASSESSMENT_ERROR_404';

      case "userResources":
        return 'MESSAGE.DETAILS_USER_RESOURCE_ERROR_404';

      case "legalEntity":
        return 'MESSAGE.DETAILS_LEGAL_ENTITY_ERROR_404';


      case "treatmentCategory":
        return 'MESSAGE.DETAILS_TREATMENT_CATEGORY_ERROR_404';

      case "technicalMeasures":
        return 'MESSAGE.DETAILS_TECHNICAL_MEASURES_ERROR_404';

      case "technicalMeasureCategories":
        return 'MESSAGE.DETAILS_TECHNICAL_MEASURES_CATEGORIES_ERROR_404';

      case "suppliers":
        return 'MESSAGE.DETAILS_SUPPLIERS_ERROR_404';

      case "regulations":
        return 'MESSAGE.DETAILS_REGULATIONS_ERROR_404';

      case "recipients":
        return 'MESSAGE.DETAILS_RECIPIENTS_ERROR_404';

      case "purposeCategory":
        return 'MESSAGE.DETAILS_PURPOSE_CATEGORY_ERROR_404';

      case "privacyRole":
        return 'MESSAGE.DETAILS_PRIVACY_ROLE_ERROR_404';

      case "preliminaryRiskAssessment":
        return 'MESSAGE.DETAILS_PRELIMINARY_RISK_ASSESSMENT_ERROR_404';

      case "organizationalMeasures":
        return 'MESSAGE.DETAILS_ORGANIZATIONAL_MEASURES_ERROR_404';

      case "organizationalMeasureCategories":
        return 'MESSAGE.DETAILS_ORGANIZATIONAL_MEASURES_CATEGORIES_ERROR_404';

      case "organizationalFunctions":
        return 'MESSAGE.DETAILS_ORGANIZATIONAL_FUNCTIONS_ERROR_404';

      case "organization":
        return 'MESSAGE.DETAILS_ORGANIZATION_ERROR_404';

      case "notices":
        return 'MESSAGE.DETAILS_NOTICES_ERROR_404';

      case "natureOfData":
        return 'MESSAGE.DETAILS_NATURE_OF_DATA_ERROR_404';

      case "legalBasis":
        return 'MESSAGE.DETAILS_LEGAL_BASIS_ERROR_404';

      case "interestedPersonCategories":
        return 'MESSAGE.DETAILS_INTERESTED_PERSON_CATEGORIES_ERROR_404';

      case "folder":
        return 'MESSAGE.DETAILS_FOLDER_ERROR_404';

      case "employmentRelationship":
        return 'MESSAGE.DETAILS_EMPLOYMENT_RELATIONSHIP_ERROR_404';

      case "damage":
        return 'MESSAGE.DETAILS_DAMAGE_ERROR_404';

      case "consoleUsers":
        return 'MESSAGE.DETAILS_CONSOLE_USERS_ERROR_404';

      case "consoleOrganizations":
        return 'MESSAGE.DETAILS_CONSOLE_ORGANIZATIONS_ERROR_404';

      case "attachment":
        return 'MESSAGE.DETAILS_ATTACHMENT_ERROR_404';

      case "appointmentsSystemAdmin":
      case "appointmentsResponsible":
      case "appointmentsAuthorized":
      case "appointments":
        return 'MESSAGE.DETAILS_APPOINTMENTS_ERROR_404';

      case "applicationTypes":
        return 'MESSAGE.DETAILS_APPLICATION_TYPES_ERROR_404';

      case "applications":
        return 'MESSAGE.DETAILS_APPLICATIONS_ERROR_404';

      case "cyberSecurity":
        return 'MESSAGE.DETAILS_CYBER_SECURITY_ERROR_404';

      case "dataBreachConfiguration":
        return 'MESSAGE.DETAILS_DATA_BREACH_CONFIGURATION_ERROR_404';

      case "email":
        return 'MESSAGE.DETAILS_EMAIL_ERROR_404';

      case "genericReport":
        return 'MESSAGE.DETAILS_GENERIC_REPORT_ERROR_404';

      case "incidentReport":
        return 'MESSAGE.DETAILS_INCIDENT_REPORT_ERROR_404';

      case "notifications":
        return 'MESSAGE.DETAILS_NOTIFICATIONS_ERROR_404';

      case "permissionRules":
        return 'MESSAGE.DETAILS_PERMISSION_RULES_ERROR_404';

      case "securityCenter":
        return 'MESSAGE.DETAILS_SECURITY_CENTER_ERROR_404';

      case "userGroups":
        return 'MESSAGE.DETAILS_USER_GROUPS_ERROR_404';

      case "versions":
        return 'MESSAGE.DETAILS_VERSIONS_ERROR_404';

      default:
        return 'MESSAGE.DETAILS_ERROR_404';
    }
  }

  public setError(error: HttpErrorResponse, ptEntity: PtEntity) {
    switch (error.status) {
      case 404:
        this.error = {
          error: error.status,
          messageKey: this.entityError(ptEntity)
        };
        break;
      case 400:
        this.error = {
          error: error.status,
          messageKey: 'MESSAGE.DETAILS_ERROR_400'
        };
        break;
      case 403:
        this.error = {
          error: error.status,
          messageKey: 'MESSAGE.DETAILS_ERROR_403'
        };
        break;
      default :
        this.error = {
          error: error.status,
          messageKey: 'MESSAGE.ERROR_OCCURRED'
        };
        break;
    }
  }

  public getError() {
    return this.error;
  }

  public setAsNotFound(ptEntity: PtEntity) {
    this.error = {
      error: 404,
      messageKey: this.entityError(ptEntity)
    };
  }
}
